const files = {
  positive: "allergy123-primary-horizontal-positive.svg",
  reversed: "allergy123-primary-horizontal-reversed.svg",
  dots: "allergy123-dots-positive.svg",
} as const;

/**
 * The released logo files, served from /brand/logos by the app's sync script.
 * Never reconstructed; never recoloured (03_logos.md). The positive lockup is
 * Cobalt, for light grounds; the reversed lockup is white, for dark grounds.
 * "auto" renders both and lets styles-v2.css show the one that matches the
 * ground (--logo-color's rule: Cobalt on light, white on dark), so it follows
 * the device like the rest of the page.
 */
export function Logo({ variant = "positive", height = 32, className }: { variant?: "positive" | "reversed" | "dots" | "auto"; height?: number; className?: string }) {
  const img = (file: string, ground?: "light" | "dark") => (
    <img key={file} src={`/brand/logos/${file}`} alt="Allergy 123" height={height} style={{ height, width: "auto" }} className={className} data-ground-only={ground} />
  );
  if (variant === "auto") return [img(files.positive, "light"), img(files.reversed, "dark")];
  return img(files[variant]);
}
